<template>
	<div
		style="
			position: relative;
			width: 100%;
			height: calc(100vh);
			display: flex;
			vertical-align: middle;
			align-items: center;
		"
	>
		<div class="text-center" style="width: 100%">
			<img
				class="animated fadeInDown"
				src="../../assets/img/logo.png"
				style="width: 400px"
			/>
			<div style="color: #2196f3" v-show="!sleep" class="fadeInDown">
				<spinner style="width: 70px; height: 70px" />
			</div>
		</div>
	</div>
</template>

<style>
.animacao-1 {
	width: 100px;
	top: 40px;
	left: -160px;
	height: 80px;
	position: fixed;
	z-index: 2;
	-webkit-animation-name: animacao-1; /* Safari 4.0 - 8.0 */
	-webkit-animation-duration: 4s; /* Safari 4.0 - 8.0 */
	animation-name: animacao-1;
	animation-duration: 19s;
}

.bk {
	position: fixed;
	width: 100%;
	height: 100%;
	/* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#f7fbfc+0,d9edf2+40,add9e4+100;Blue+3D+%231 */
	background: rgb(247, 251, 252); /* Old browsers */
	background: -moz-linear-gradient(
		top,
		rgba(247, 251, 252, 1) 0%,
		rgba(217, 237, 242, 1) 40%,
		rgba(173, 217, 228, 1) 100%
	); /* FF3.6-15 */
	background: -webkit-linear-gradient(
		top,
		rgba(247, 251, 252, 1) 0%,
		rgba(217, 237, 242, 1) 40%,
		rgba(173, 217, 228, 1) 100%
	); /* Chrome10-25,Safari5.1-6 */
	background: linear-gradient(
		to bottom,
		rgba(247, 251, 252, 1) 0%,
		rgba(217, 237, 242, 1) 40%,
		rgba(173, 217, 228, 1) 100%
	); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f7fbfc', endColorstr='#add9e4',GradientType=0 ); /* IE6-9 */
}

/* Safari 4.0 - 8.0 */
@-webkit-keyframes animacao-1 {
	0% {
		left: -160px;
		top: 40px;
	}
	100% {
		left: -160px;
		width: 115%;
		top: 40px;
	}
}

/* Standard syntax */
@keyframes animacao-1 {
	0% {
		left: -160px;
		top: 40px;
	}
	100% {
		left: -160px;
		width: 115%;
		top: 40px;
	}
}

.animacao-2 {
	width: 100px;
	height: 100px;
	top: 320px;
	right: -160px;
	position: fixed;
	z-index: 2;
	-webkit-animation-name: animacao-2; /* Safari 4.0 - 8.0 */
	-webkit-animation-duration: 4s; /* Safari 4.0 - 8.0 */
	animation-name: animacao-2;
	animation-duration: 19s;
}

/* Safari 4.0 - 8.0 */
@-webkit-keyframes animacao-2 {
	0% {
		right: -160px;
		top: 320px;
	}
	100% {
		right: -160px;
		width: 115%;
		top: 320px;
	}
}

/* Standard syntax */
@keyframes animacao-2 {
	0% {
		right: -160px;
		top: 320px;
	}
	100% {
		right: -160px;
		width: 115%;
		top: 320px;
	}
}
</style>

<script>
import {setTimeout} from 'timers'

const {detect} = require('detect-browser')
const browser = detect()

export default {
	data() {
		return {
			load: true,
			naoIdentificou: '',
			naoSuportado: false,
			manutencao: false,
			animacao: true,
			sleep: true
		}
	},

	created() {
		this.sleepAnimacao()
	},

	mounted() {
		this.validaNavegador()
		this.restartAnimacao()
	},

	methods: {
		sleepAnimacao() {
			setTimeout(() => {
				this.sleep = false
			}, 360)
		},
		restartAnimacao() {
			setTimeout(() => {
				this.animacao = false

				this.$nextTick(() => {
					this.animacao = true
					this.restartAnimacao()
				})
			}, 33000)
		},

		validaTls() {
			var userAgent = window.navigator.userAgent.toLowerCase()
			var supportForTLS = false

			// Chrome, Edge e Safari
			if (userAgent.indexOf('applewebkit/') > -1) {
				let userAgentVersion = Number(
					userAgent.split('applewebkit/')[1].split('.')[0]
				)

				if (userAgentVersion > 536) {
					supportForTLS = true
				}
			}

			if (!supportForTLS) {
				this.naoSuportado = true
				this.naoIdentificou = 'TLS'
			}
		},

		validaNavegador() {
			var split = browser.version.split('.')
			var version = 0

			if (split.length > 0) {
				version = Number(split[0] + '.' + split[1])
			} else {
				version = Number(split[0])
			}

			//this.validaTls()

			if (browser) {
				if (browser.name == 'chrome') {
					if (version < 70) {
						this.naoSuportado = true
						this.naoIdentificou = 'SUPORTADO'
					}
				} else if (browser.name == 'firefox') {
					if (version < 63) {
						this.naoSuportado = true
						this.naoIdentificou = 'SUPORTADO'
					}
				} else if (browser.name == 'ie') {
					if (version < 9) {
						this.naoSuportado = true
						this.naoIdentificou = 'SUPORTADO'
					}
				}
				if (browser.name == 'edge') {
					if (version < 15) {
						this.naoSuportado = true
						this.naoIdentificou = 'SUPORTADO'
					}
				}
			} else {
				this.load = false
				this.naoSuportado = true
				this.naoIdentificou = 'NAVEGADOR'
			}

			if (this.naoSuportado) {
				this.load = false
				this.animacao = false
			} else {
				this.carregaCliente(false)
			}
		},

		clickVerifica() {
			this.carregaCliente(true)
		},

		carregaCliente(load) {
			var self = this

			if (load) {
				bus.$emit('load-in', {text: 'Verificando'})
			}

			this._carregaCliente()

			bus.$on('cliente-carregado', (cliente) => {
				if (load) {
					bus.$emit('load-out')
				}

				if (cliente.manutencao == true) {
					$cliente.set({})
					this.load = false
					this.manutencao = true
				} else {
					location.reload(true)
				}
			})

			if ($cliente.get('id') != null) {
				this.$router.replace({name: 'login'})
			}
		}
	}
}
</script>